export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
  imageSeq: string;
  imagePrompt: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'josei-romance',
    name: '女性向恋爱',
    description: '以女性读者为主要受众，注重情感描写与人物心理刻画，画风精致细腻，剧情发展自然流畅，强调两性关系的深度与温度。',
    icon: 'ri-heart-line',
    articleCount: 28,
    imageSeq: 'cat-josei-01',
    imagePrompt: 'Elegant soft watercolor illustration of a couple silhouette in warm sunset tones, artistic brush strokes, romantic atmosphere, abstract impressionist style, gentle pink and gold hues, delicate composition, fine art quality',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20soft%20watercolor%20illustration%20of%20a%20couple%20silhouette%20in%20warm%20sunset%20tones%2C%20artistic%20brush%20strokes%2C%20romantic%20atmosphere%2C%20abstract%20impressionist%20style%2C%20gentle%20pink%20and%20gold%20hues%2C%20delicate%20composition%2C%20fine%20art%20quality&width=600&height=400&seq=cat-josei-01&orientation=landscape',
  },
  {
    slug: 'seinen-drama',
    name: '青年向剧情',
    description: '面向成年男性读者，故事情节更加成熟复杂，涉及社会议题、职场关系与人性探讨，画面表现力强，具有深度叙事结构。',
    icon: 'ri-movie-line',
    articleCount: 35,
    imageSeq: 'cat-seinen-01',
    imagePrompt: 'Dramatic ink wash painting style urban night scene with lone figure silhouette, deep atmospheric shadows, moody lighting, contemporary Japanese art influence, minimalist composition with bold contrasts, charcoal gray and muted amber tones',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20ink%20wash%20painting%20style%20urban%20night%20scene%20with%20lone%20figure%20silhouette%2C%20deep%20atmospheric%20shadows%2C%20moody%20lighting%2C%20contemporary%20Japanese%20art%20influence%2C%20minimalist%20composition%20with%20bold%20contrasts%2C%20charcoal%20gray%20and%20muted%20amber%20tones&width=600&height=400&seq=cat-seinen-01&orientation=landscape',
  },
  {
    slug: 'fantasy-isekai',
    name: '奇幻异世界',
    description: '以架空世界观为背景的成人漫画，融合魔法、冒险与奇幻元素，在异世界设定中展开成人向叙事，想象力丰富且设定严谨。',
    icon: 'ri-magic-line',
    articleCount: 42,
    imageSeq: 'cat-fantasy-01',
    imagePrompt: 'Mystical fantasy landscape with floating islands and ethereal light beams, dark fantasy aesthetic, dramatic sky with golden rim lighting, painterly digital art style, deep teal and amber palette, atmospheric and immersive',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mystical%20fantasy%20landscape%20with%20floating%20islands%20and%20ethereal%20light%20beams%2C%20dark%20fantasy%20aesthetic%2C%20dramatic%20sky%20with%20golden%20rim%20lighting%2C%20painterly%20digital%20art%20style%2C%20deep%20teal%20and%20amber%20palette%2C%20atmospheric%20and%20immersive&width=600&height=400&seq=cat-fantasy-01&orientation=landscape',
  },
  {
    slug: 'slice-of-life',
    name: '日常温情',
    description: '以日常生活为背景的成人向作品，聚焦成年人际关系与情感世界，节奏舒缓真实，通过平凡日常展现深刻情感。',
    icon: 'ri-home-heart-line',
    articleCount: 20,
    imageSeq: 'cat-slice-01',
    imagePrompt: 'Warm cozy interior scene with soft afternoon sunlight streaming through window curtains, lived-in apartment aesthetic, gentle shadows, intimate atmosphere, muted earth tones, impressionistic digital painting, calm and nostalgic mood',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20interior%20scene%20with%20soft%20afternoon%20sunlight%20streaming%20through%20window%20curtains%2C%20lived-in%20apartment%20aesthetic%2C%20gentle%20shadows%2C%20intimate%20atmosphere%2C%20muted%20earth%20tones%2C%20impressionistic%20digital%20painting%2C%20calm%20and%20nostalgic%20mood&width=600&height=400&seq=cat-slice-01&orientation=landscape',
  },
  {
    slug: 'thriller-mystery',
    name: '悬疑惊悚',
    description: '融合悬疑推理与惊悚元素的成人漫画，情节紧凑引人入胜，心理描写深刻，画风沉稳有力，营造紧张氛围的同时保留艺术美感。',
    icon: 'ri-shield-flash-line',
    articleCount: 25,
    imageSeq: 'cat-thriller-01',
    imagePrompt: 'Noir style dark alleyway with dramatic street lamp lighting casting long shadows, mysterious atmosphere, film grain texture, monochromatic with subtle crimson accents, cinematic composition, tension-filled urban scene',
    imageUrl: 'https://readdy.ai/api/search-image?query=Noir%20style%20dark%20alleyway%20with%20dramatic%20street%20lamp%20lighting%20casting%20long%20shadows%2C%20mysterious%20atmosphere%2C%20film%20grain%20texture%2C%20monochromatic%20with%20subtle%20crimson%20accents%2C%20cinematic%20composition%2C%20tension-filled%20urban%20scene&width=600&height=400&seq=cat-thriller-01&orientation=landscape',
  },
  {
    slug: 'historical-drama',
    name: '历史风韵',
    description: '以历史时期为背景的成人漫画，考究的时代还原与服饰设计，在历史框架下探讨人性与情感，兼具文化深度与艺术价值。',
    icon: 'ri-ancient-gate-line',
    articleCount: 18,
    imageSeq: 'cat-hist-01',
    imagePrompt: 'Traditional East Asian ink painting of ancient architecture with cherry blossom petals drifting in moonlight, classical aesthetic, silk scroll texture, muted jade and vermillion accents, refined composition, cultural heritage atmosphere',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20East%20Asian%20ink%20painting%20of%20ancient%20architecture%20with%20cherry%20blossom%20petals%20drifting%20in%20moonlight%2C%20classical%20aesthetic%2C%20silk%20scroll%20texture%2C%20muted%20jade%20and%20vermillion%20accents%2C%20refined%20composition%2C%20cultural%20heritage%20atmosphere&width=600&height=400&seq=cat-hist-01&orientation=landscape',
  },
  {
    slug: 'sci-fi-cyber',
    name: '科幻赛博',
    description: '以未来科技世界为舞台的成人漫画，探讨科技与人性的边界，赛博朋克风格视觉效果突出，兼具思想性与视觉冲击力。',
    icon: 'ri-cpu-line',
    articleCount: 22,
    imageSeq: 'cat-scifi-01',
    imagePrompt: 'Cyberpunk cityscape at night with neon reflections on wet streets, holographic advertisements, rain-slicked atmosphere, futuristic yet moody aesthetic, deep indigo and electric amber contrasts, digital painting with film grain',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cyberpunk%20cityscape%20at%20night%20with%20neon%20reflections%20on%20wet%20streets%2C%20holographic%20advertisements%2C%20rain-slicked%20atmosphere%2C%20futuristic%20yet%20moody%20aesthetic%2C%20deep%20indigo%20and%20electric%20amber%20contrasts%2C%20digital%20painting%20with%20film%20grain&width=600&height=400&seq=cat-scifi-01&orientation=landscape',
  },
  {
    slug: 'yaoi-bl',
    name: '耽美BL',
    description: '以男性之间的情感关系为主题的成人漫画，注重人物塑造与情感表达，画风唯美精致，在日本及亚洲市场拥有广泛读者群。',
    icon: 'ri-user-heart-line',
    articleCount: 30,
    imageSeq: 'cat-bl-01',
    imagePrompt: 'Delicate ethereal illustration of two silhouettes against a dreamy starlit sky, soft watercolor washes, flowing lines, romantic and poetic atmosphere, pastel lavender and silver tones, shoujo-inspired aesthetic, graceful composition',
    imageUrl: 'https://readdy.ai/api/search-image?query=Delicate%20ethereal%20illustration%20of%20two%20silhouettes%20against%20a%20dreamy%20starlit%20sky%2C%20soft%20watercolor%20washes%2C%20flowing%20lines%2C%20romantic%20and%20poetic%20atmosphere%2C%20pastel%20lavender%20and%20silver%20tones%2C%20shoujo-inspired%20aesthetic%2C%20graceful%20composition&width=600&height=400&seq=cat-bl-01&orientation=landscape',
  },
];